import axios from "axios";

import { successHandling } from "../helpers/successHandling";

export const updateFolderNameAPI = async (
  storedValue,
  value,
  id,
  parentId,
  setStoredValue,
  setValue,
  t,
  successfulText
) => {
  try {
    await axios({
      url: `/api/v2/drive/file/rename-folder`,
      method: "GET",
      params: {
        id: id,
        name: value,
        parent_id: parentId
      }
    });

    successHandling(t, successfulText);
    setStoredValue(value);
  } catch (error) {
    setValue(storedValue);
  }
};
